<template>
  <div id="TalkDetail" class="sun">
    <DeleteAnswerModal
      v-if="isPopupDelete"
      @executeDelete="executeDelete"
      @cancelDelete="cancelDelete"
    />
    <div class="scroll">
      <Question
        v-if="getQuestion.data"
        :mode="'detail'"
        :question="getQuestion.data"
        @editQuestion="editQuestion"
        @removeQuestion="removeQuestion"
      />
      <div
        v-infinite-scroll="loadNextAnswers"
        infinite-scroll-disabled="busy"
        infinite-scroll-distance="500"
      >
        <AnswerList
          v-if="
            answers.length >= 1 &&
            getQuestion.data &&
            getQuestion.data.user &&
            getQuestion.data.is_answer_active
          "
          :answers="answers"
          @editAnswer="editAnswer"
          @removeAnswer="removeAnswer"
        />
      </div>
    </div>
    <TalkInput
      v-if="
        getQuestion.data &&
        getQuestion.data.user &&
        getQuestion.data.is_answer_active
      "
      @updateQuestion="updateQuestion"
      @cancelQuestion="cancelQuestion"
      @createAnswer="createAnswer"
      @updateAnswer="updateAnswer"
      @cancelAnswer="cancelAnswer"
      :answerEdit="answerEdit"
      :questionEdit="questionEdit"
    />
  </div>
</template>

<script>
// Store
import store from '@/store'
import { mapActions } from 'vuex'

// Components Section
import Question from './components/Question'
import AnswerList from './components/AnswerList'
import TalkInput from './components/TalkInput'
import DeleteAnswerModal from './components/DeleteAnswerModal'

// Variable Section
let self

export default {
  name: 'Detail',
  components: {
    Question,
    AnswerList,
    TalkInput,
    DeleteAnswerModal,
  },
  chimera: {
    // Question
    getQuestion() {
      return {
        url: `/talks/questions/${this.$route.params.uuid}/`,
        method: 'get',
      }
    },
    deleteQuestion() {
      return {
        url: `/talks/questions/${
          this.questionRemove ? this.questionRemove.uuid : ''
        }/`,
        method: 'delete',
      }
    },
    viewQuestion() {
      return {
        url: `/talks/questions/${this.$route.params.uuid}/view/`,
        method: 'post',
      }
    },
    // Answer
    getAnswers() {
      return {
        url: '/talks/answers/',
        method: 'get',
        params: {
          question__uuid: this.$route.params.uuid,
        },
      }
    },
    getNextAnswers() {
      return {
        url: `${this.next}`,
        method: 'get',
        params: {
          question__uuid: this.$route.params.uuid,
        },
      }
    },
    deleteAnswer() {
      return {
        url: `/talks/answers/${
          this.answerRemove ? this.answerRemove.uuid : ''
        }/`,
        method: 'delete',
      }
    },
  },
  data: function () {
    return {
      questionEdit: null,
      answerEdit: null,
      isPopupDelete: false,
      questionRemove: null,
      answerRemove: null,

      // Answers
      answers: [],
      next: null,
      isLoading: false,
    }
  },
  computed: {},
  async created() {
    self = this
    self.$store.commit('ui/headerTitle', '나우 톡톡!')
    await this.getQuestion.fetch()

    // store 에 현재 보고있는 글 저장
    this.setItem(this.getQuestion.data)
    await this.viewQuestion.fetch()

    // Get Answers
    await self.loadAnswers()
  },
  methods: {
    ...mapActions('talks', ['setItem', 'clear']),
    // Answers
    setAnswers(data) {
      if (data.results && data.results.length >= 1) {
        this.answers = this.answers.concat(data.results)
      }
      if (data.next) {
        this.next = data.next.replace(store.state.env.baseURL, '')
      }
    },
    async loadAnswers() {
      this.answers = []
      await this.getAnswers.fetch()
      this.setAnswers(this.getAnswers.data)
    },
    async loadNextAnswers() {
      // Check next
      if (!(this.next && !this.isLoading)) {
        return
      }
      this.isLoading = true
      await this.getNextAnswers.fetch()
      this.isLoading = false
      this.next = null
      this.setAnswers(this.getNextAnswers.data)
    },

    scrollToElement(elementId) {
      let element = document.getElementById(elementId)
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' })
      }
    },

    // Edit / Remove / Create / Update
    async editQuestion(question) {
      this.questionEdit = question
      if (question) {
        this.scrollToElement('Question-' + question.uuid)
      }
    },
    async updateQuestion(question) {
      await this.getQuestion.fetch()
      if (question) {
        this.scrollToElement('Question-' + question.uuid)
      }
    },
    async cancelQuestion(question) {
      await this.getQuestion.fetch()
      if (question) {
        this.scrollToElement('Question-' + question.uuid)
      }
    },
    async editAnswer(answer) {
      this.answerEdit = answer
      if (answer) {
        this.scrollToElement('Answer-' + answer.uuid)
      }
    },
    async createAnswer(answer) {
      await this.loadAnswers()
      if (answer) {
        this.scrollToElement('Answer-' + answer.uuid)
      }
    },
    async updateAnswer(answer) {
      await this.loadAnswers()
      if (answer) {
        this.scrollToElement('Answer-' + answer.uuid)
      }
    },
    async cancelAnswer(answer) {
      await this.loadAnswers()
      if (answer) {
        this.scrollToElement('Answer-' + answer.uuid)
      }
    },
    async removeQuestion(question) {
      this.questionRemove = question
      this.isPopupDelete = true
    },
    async removeAnswer(answer) {
      this.answerRemove = answer
      this.isPopupDelete = true
    },

    // Popup
    async executeDelete() {
      if (this.questionRemove) {
        await this.deleteQuestion.fetch()

        // 게시글 삭제하는 경우 store에 저장된 목록 비움
        this.clear()

        await this.$router.push({ name: 'talks' })
        this.isPopupDelete = false
      } else if (this.answerRemove) {
        await this.deleteAnswer.fetch()
        this.isPopupDelete = false
        await this.loadAnswers()
      }
    },
    async cancelDelete() {
      this.isPopupDelete = false
    },
  },
}
</script>

<style lang="scss" scoped>
#TalkDetail {
  width: 100%;
  max-width: inherit;
  height: calc(100vh - 60px);
  background-color: #f6f6f6;
  .scroll {
    width: 100%;
    height: calc(100% - 60px);
    overflow: scroll;
    padding-bottom: 150px;
  }
}
</style>
